import React, { useEffect, useState } from 'react'
import { BasicModalCPProps, ModalCP } from 'submodules/nerit-framework-ui/common/components/modal/ModalCP'
import { useFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/UseFormStateManager'
import { QAQCExecuteFormModel } from 'modules/reports/screens/screen-charts/content/qaqc/inner/QAQCExecuteFormModel'
import { SelectSamplingsCP } from 'modules/samplings/components/select-samplings/SelectSamplingsCP'
import { SelectLocationCP } from 'common/components/form/SelectLocationCP'
import { SelectFieldRegulationCP } from 'common/components/form/SelectFieldRegulationCP'
import { SelectFieldCP } from 'modules/fields/components/select-field/SelectFieldCP'
import { InputCP } from 'submodules/nerit-framework-ui/common/components/form-fields/input/InputCP'
import { DateRangePickerCP } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/DateRangePickerCP'
import { ColumnCP } from 'submodules/nerit-framework-ui/common/components/grid/column/ColumnCP'
import { RowCP } from 'submodules/nerit-framework-ui/common/components/grid/row/RowCP'
import { FormStateManagerUtils } from 'submodules/nerit-framework-ui/common/form-state-manager/FormStateManagerUtils'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { ChartsRequests } from 'submodules/nerit-aquatec-sdk/services/charts/ChartsRequests'
import { SamplingDataResponseDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/responses/SamplingDataResponseDTO'
import { QAQCRequests } from 'submodules/nerit-aquatec-sdk/services/qaqc/QAQCRequests'
import { QAQCExecuteRequestDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/requests/QAQCExecuteRequestDTO'
import { QAQCExecutionTypeEnum } from 'submodules/nerit-aquatec-sdk/common/enums/QAQCExecutionTypeEnum'
import styled from 'styled-components'

interface ICPProps extends BasicModalCPProps {
	type: QAQCExecutionTypeEnum
}


/**
 */
export function ModalQAQCExecuteCP(props: ICPProps): JSX.Element {

	const [formModel, setFormModel] = useState<QAQCExecuteFormModel>(new QAQCExecuteFormModel())
	const formStateManager = useFormStateManager(formModel)

	const getSamplingDataRequest = useRequest<SamplingDataResponseDTO>()
	const executeRequest = useRequest<void>('none')

	useEffect(onGetSamplingDataChange, [getSamplingDataRequest.isAwaiting])
	useEffect(onExecuteRequestChange, [executeRequest.isAwaiting])
	const samplingCode = formStateManager.getFieldValue('samplingCode')
	useEffect(onSelectSampling, [samplingCode])
	useEffect(init, [props.visible])

	function init(): void {
		if (props.visible) {
			setFormModel(new QAQCExecuteFormModel())
		}
	}

	function onSelectSampling(): void {
		const samplingCode = formStateManager.getFieldValue('samplingCode')
		if (!samplingCode) return
		getSamplingDataRequest.runRequest(ChartsRequests.getSamplingData(samplingCode))
	}

	function onGetSamplingDataChange(): void {
		if (!RequestUtils.isValidRequestReturn(getSamplingDataRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE))
			return
		const result = getSamplingDataRequest.responseData!
		formStateManager.changeFieldValue('locationCodes', result.locations.map((loc) => loc.code))
	}

	async function doExecute(): Promise<void> {
		if (!await FormStateManagerUtils.validateRequiredFields(formStateManager))
			return
		const formValues = formStateManager.getFormValues()!
		const dto: QAQCExecuteRequestDTO = {
			identification: formValues.identification!,
			regulationCode: formValues.fieldRegulationCode!,
			locationCodes: formValues.locationCodes!,
			dateRange: formValues.dateRange ? {
				beginDate: formValues.dateRange.beginDate,
				endDate: formValues.dateRange.endDate,
			} : undefined,
			fieldCodes: formValues.fieldCodes,
		}
		const executeRequestTP = props.type === QAQCExecutionTypeEnum.ANOMALY_EVALUATION
			? QAQCRequests.executeAnomalyEvaluation(dto)
			: QAQCRequests.executeIonicBalance(dto)
		executeRequest.runRequest(executeRequestTP)
	}

	function onExecuteRequestChange(): void {
		if (!RequestUtils.isValidRequestReturn(executeRequest, 'Erro ao executar QA/QC', 'Execução iniciada com sucesso', true))
			return
		props.onSave()
	}

	return (
		<ModalCP
			visible={props.visible}
			title={'Nova Execução'}
			onCancel={props.onCancel}
			onOk={doExecute}
			okText={'Executar'}
			actionLoading={executeRequest.isAwaiting}
			disableOutsideClickClosing={true}
			width={600}
			top={45}
		>
			<ModalContentWrapper>
			<RowCP>
				<ColumnCP size={24}>
					<SelectSamplingsCP
						isRequired={true}
						formStateManager={formStateManager}
						fieldName={'samplingCode'}
					/>
				</ColumnCP>
			</RowCP>
			<RowCP>
				<ColumnCP size={24}>
					<InputCP
						formStateManager={formStateManager}
						fieldName={'identification'}
						label={'Identificação'}
						required={true}
					/>
				</ColumnCP>
			</RowCP>
			<RowCP>
				<ColumnCP size={24}>
					<SelectLocationCP
						isMany={true}
						formStateManager={formStateManager}
						fieldName={'locationCodes'}
						isRequired={true}
						maxTagCount={1}
					/>
				</ColumnCP>
			</RowCP>
			<RowCP>
				<ColumnCP size={24}>
					<SelectFieldRegulationCP
						isRequired={true}
						formStateManager={formStateManager}
						fieldName={'fieldRegulationCode'}
					/>
				</ColumnCP>
			</RowCP>
			<RowCP>
				<ColumnCP size={24}>
					<SelectFieldCP
						formStateManager={formStateManager}
						fieldName={'fieldCodes'}
						isMany={true}
						maxTagCount={1}
					/>
				</ColumnCP>
			</RowCP>
			<RowCP>
				<ColumnCP size={24}>
					<DateRangePickerCP
						showBorder={true}
						marginTop={23}
						fastFilter={'all'}
						fieldName={'dateRange'}
						formStateManager={formStateManager}
					/>
				</ColumnCP>
			</RowCP>
			</ModalContentWrapper>
		</ModalCP>
	)
}

const ModalContentWrapper = styled.div`
	width: 100%;
	.ant-select,
	.ant-input,
	.ant-picker,
	.ant-picker-range {
		width: 100% !important;
	}
`
